import React from "react";

function Lang({ mode }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 24 24"
      fill={ mode === "light" ? "#464646": "#bfbfbf" }
    >
      <path d="M23 10.826v2.349c-1.562 0-3 1.312-3 2.857C20 18.213 21.281 22 14 22v-2.002c4.917 0 3.966-1.6 3.966-3.967 0-2.094 1.211-3.5 2.278-4.031-1.067-.531-2.278-1.438-2.278-3.312 0-2.372.94-4.692-3.966-4.686V2c7.285 0 6 4.506 6 6.688 0 1.544 1.438 2.138 3 2.138zM4 8.688C4 6.506 2.715 2 10 2v2.002c-4.906-.007-3.966 2.313-3.966 4.686 0 1.875-1.211 2.781-2.278 3.312 1.067.531 2.278 1.938 2.278 4.031 0 2.367-.951 3.967 3.966 3.967V22c-7.281 0-6-3.787-6-5.969 0-1.545-1.438-2.857-3-2.857v-2.349c1.562.001 3-.593 3-2.137z"></path>
    </svg>
  );
}

export default Lang;
